<template>
  <div class="detail-wrapper">
    <div class="prodet-bg">
      <div class="container">
        <div class="por-box-location">
          <Icon custom="ich-icon ich-icon-map" size="18" />
          <span>
            {{ courseInfo.courseName }} | 包含班级：
            <span style="margin-right: 8px">正在播放</span>
            <b style="font-weight: normal">{{ courseInfo.specialName }}</b>
            <b
              style="color: #ff5f72; font-weight: normal"
              v-if="currentSpecial.hasLive"
              >(包含直播)</b
            >
          </span>
        </div>
        <div class="prodet-player clearfix">
          <div class="prodet-box-c">
            <video-player
              :width="800"
              :loading="!isLoaded"
              :tipText="noVideoText"
            ></video-player>
          </div>
          <div class="prodet-box-d clearfix">
            <div class="prodet-boxd-a">
              <course-catalog v-if="currentSpecial.type === 1"></course-catalog>
              <review-catalog v-if="currentSpecial.type === 2"></review-catalog>
            </div>
            <div class="prodet-boxd-b">
              <div class="prodet-pt-a">
                <Icon custom="ich-icon ich-icon-catalog" />
                <p>目录</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 购买区域 -->
      <div class="container prodet-action clearfix">
        <div class="prodet-box-f">
          <p
            class="prodet-boxf-b"
            v-show="
              formatPrice(
                productInfo.reducedPrice,
                productInfo.marketPrice
              )[1] !== '-1'
            "
          >
            ¥{{
              formatPrice(productInfo.reducedPrice, productInfo.marketPrice)[1]
            }}
          </p>
          <p
            class="prodet-boxf-c"
            v-show="
              formatPrice(
                productInfo.reducedPrice,
                productInfo.marketPrice
              )[0] !== '-1'
            "
          >
            <span style="font-size: 22px">￥</span>
            <span id="product-price">
              {{
                formatPrice(
                  productInfo.reducedPrice,
                  productInfo.marketPrice
                )[0]
              }}
            </span>
          </p>

          <Button v-if="isBuy" shape="circle" disabled>已购买</Button>
          <Button
            v-else-if="productInfo.reducedPrice"
            type="warning"
            shape="circle"
            @click="buyProduct"
          >
            立即购买
          </Button>
          <Button v-else shape="circle" disabled>立即购买</Button>
        </div>
      </div>
    </div>

    <div class="container clearfix">
      <!-- 各类详情 -->

      <div class="product-detail">
        <div class="product-info-bar">课程介绍</div>
        <h3 class="product-info-title">
          {{ courseInfo.courseName }}
        </h3>
        <ul class="product-info-body">
          <li>
            <div class="info-item">
              <span>•</span>
              课程代码：
            </div>
            <div class="info-content">{{ courseInfo.courseNo }}</div>
          </li>
          <li>
            <template
              v-if="
                Object.keys(productInfo).length > 0 &&
                siteConfig.isShowProductValid == 1
              "
            >
              <div class="info-item">
                <span>•</span>
                有效期：
              </div>
              <div class="info-content">{{ productInfo.validTime }}</div>
            </template>
          </li>
          <li>
            <div class="info-item">
              <span>•</span>
              所属地区：
            </div>
            <div class="info-content">
              <em
                v-for="(item, index) in productInfo.provinceList"
                :key="index"
              >
                {{ item.name }} &nbsp;
              </em>
            </div>
          </li>
          <li>
            <div class="info-item">
              <span>•</span>
              考试时间：
            </div>
            <div class="info-content">
              <template
                v-if="
                  courseInfo.examTimeList && courseInfo.examTimeList.length > 0
                "
              >
                <p
                  v-for="(item, index) in courseInfo.examTimeList"
                  :key="index"
                >
                  <span>{{ item.province ? item.province : "------" }}</span>
                  <span style="margin-left: 30px">{{ item.examDate }}</span>
                  <span style="margin-left: 10px">
                    {{ item.startTime }}-{{ item.endTime }}
                  </span>
                </p>
              </template>
              <p v-else>待确定</p>
            </div>
          </li>
        </ul>
        <div>
          <h4 class="product-info-sub" style="float: left">包含班型：</h4>
          <div style="float: right; padding: 15px 0 10px 0">
            <span class="product-info-btn" @click="showCourseFunc"
              >课程信息</span
            >
          </div>
        </div>
        <div style="clear: both"></div>
        <div class="product-course-list">
          <dl v-for="(item, index) in courseList" :key="index">
            <!-- <dt>[{{ item.courseId }}]{{ item.courseName }}</dt> -->
            <dd
              v-for="(special, speIndex) in item.coursespecialtypeList"
              :key="speIndex"
            >
              <span :style="{ color: special.hasLive ? '#ff5f72' : '#333' }">{{
                special.specialName
              }}</span>
              <span style="color: #ff5f72" v-if="special.hasLive"
                >(包含直播)</span
              >
            </dd>
          </dl>
        </div>
        <h4 class="product-info-sub">包含课程视频：</h4>
        <ul
          class="product-info-body"
          v-if="courseStatisticsInfo.courseSpecialTypesByCourse"
        >
          <li v-for="(item, index) in specialStatisticsWithVideo" :key="index">
            <div class="info-item">
              <span>•</span>
              {{ item.specialName }}：
            </div>
            <div class="info-content">
              <span>
                课时：
                <b class="color2">{{ item.pptTime }}</b>
                分钟
              </span>
              <span>
                视频：
                <b class="color2">{{ item.pptNum }}</b>
                个
              </span>
              <!-- <span> 有效期：{{ item.endTime }} </span> -->
            </div>
          </li>
        </ul>
        <h4 class="product-info-sub">包含课程题库：</h4>
        <ul
          class="product-info-body"
          v-if="courseStatisticsInfo.courseSpecialTypesByCourse"
        >
          <li
            v-for="(item, index) in specialStatisticsWithExercise"
            :key="index"
          >
            <div class="info-item">
              <span>•</span>
              {{ item.specialName }}：
            </div>
            <!-- <div v-if="item.specialType === 3" class="info-content">
              <span
                ><b class="color2">{{ item.exerNum }}</b> 题</span
              >
            </div> -->
            <div v-if="item.specialType === 4" class="info-content">
              <span>
                <b class="color2">{{ item.simExamAmountNum }}</b>
                题
                <b class="color2">{{ item.simExamItem }}</b>
                套
              </span>
              <!-- <span> 有效期：{{ item.endTime }} </span> -->
            </div>
            <div v-else class="info-content">
              <span>
                <b class="color2">{{ item.exerNum }}</b>
                题
              </span>
              <!-- <span> 有效期：{{ item.endTime }} </span> -->
            </div>
          </li>
        </ul>

        <!-- 课程信息弹框 -->
        <Modal
          v-model="courseflag"
          :closable="true"
          :mask-closable="true"
          footer-hide
          class-name="vertical-center-modal"
        >
          <div
            style="
              text-align: center;
              max-height: 500px;
              overflow-y: auto;
              overflow-x: hidden;
              position: relative;
            "
          >
            <div
              style="
                text-align: left;
                font-size: 18px;
                font-weight: 600;
                position: fixed;
                background-color: #ffffff;
                width: 500px;
                line-height: 10px;
                height: 20px;
                border-bottom: 1px solid #cccccc;
              "
            >
              课程信息
            </div>
            <div style="width: 500px; height: 15px"></div>
            <div
              v-for="(special, index) in productCourse"
              style="border-bottom: 1px solid #cccccc"
              :key="index"
            >
              <div
                style="
                  text-align: left;
                  font-size: 18px;
                  padding: 10px 0;
                  font-weight: 600;
                "
              >
                {{ special.courseName }}
              </div>
              <template v-for="(cdpItem, cdpI) in special.courseSon.ppt">
                <div
                  style="text-align: left; font-size: 18px; padding: 0 0 10px 0"
                  :key="cdpI"
                >
                  <span>•</span>{{ cdpItem.name }}：
                  <span
                    >课时：<b class="color2">{{ cdpItem.ppttime }}</b
                    >分钟</span
                  >
                  <span style="padding: 0 0 0 15px"
                    >视频：<b class="color2">{{ cdpItem.pptnum }}</b
                    >个</span
                  >
                </div>
              </template>
              <div style="height: 10px"></div>
              <template v-for="(cdeItem, cdeI) in special.courseSon.exe">
                <div
                  style="text-align: left; font-size: 18px; padding: 0 0 10px 0"
                  :key="cdeI"
                >
                  <span>•</span>{{ cdeItem.name }}：
                  <span class="info-content">
                    <span
                      ><b class="color2">{{ cdeItem.exernum }}</b
                      >题<b
                        class="color2"
                        style="padding: 0 0 0 15px"
                        v-if="cdeItem.specialids != '-'"
                        >{{ cdeItem.specialids }}</b
                      ><span v-if="cdeItem.specialids != '-'">套</span></span
                    >
                  </span>
                </div>
              </template>
            </div>
          </div>
        </Modal>

        <h4 class="product-info-sub">使用教材</h4>
        <div class="product-info-textbook">
          <div v-for="item in courseStatisticsInfo.tchMaterialList" :key="item.courseId" class="product-info-center">
            <div class="textbook-img">
              <img
                :src="concatImageUrl(item.coverPic, 68, 98)"
                alt="教材名称"
                style="width: 68px; height: 98px"
                v-if="item.coverPic"
              />
              <img v-else src="../../assets/images/v3/material-default.png" />
            </div>

            <div class="textbook-info">
              <div class="textbook-name">
                <Tooltip :content="`《${item.matName}》`" max-width="400" placement="top-start">
                  <div class="textbook-name-in">
                    《{{ item.matName }}》
                  </div>
                </Tooltip>
              </div>
              <span>
                <b>主编：</b>
                {{ item.writer }}
              </span>
              <br />
              <span>
                <b>版次：</b>
                {{ item.pubNo }}
              </span>
              <span>
                <b>出版社：</b>
                {{ item.pubName }}
              </span>
            </div>
            <div class="product-info-line"></div>
          </div>
        </div>
        <div class="product-info-detail" v-html="productInfo.intro"></div>
      </div>

      <!-- 侧边栏 -->
      <div class="product-sider">
        <div class="product-info-bar">师资简介</div>
        <teacher-slider :dataList="teacherList"></teacher-slider>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "../../components/common/VideoPlayer";
import CourseCatalog from "./CourseCatalog";
import ReviewCatalog from "./ReviewCatalog";
import TeacherSlider from "./TeacherSlider";

import { siteMixin } from "../../utils/mixin";
import { mall, study } from "../../request";
import { saveBuyProduct } from "../../utils/localStorage";

export default {
  mixins: [siteMixin],
  data() {
    return {
      currentTab: 1,
      productInfo: {},
      courseList: [],
      courseInfo: {},
      currentSpecial: {},
      noVideoText: "",
      specialStatisticsWithVideo: [],
      specialStatisticsWithExercise: [],
      teacherList: [],
      isLoaded: false,
      courseStatisticsInfo: {},
      courseflag: false,
      productCourse: [],
    };
  },
  mounted() {
    this.initProductOrCourseData();
  },
  methods: {
    initProductOrCourseData() {
      const productId = this.$route.params.id;
      if (productId) {
        this.setProductId(productId);
        this.getProductInfo();
      }
      mall.productCourseDetail(this.productId).then((res) => {
        if (res.status == 1) {
          this.productCourse = res.data;
        }
      });
    },
    //显示课程信息
    showCourseFunc() {
      this.courseflag = true;
    },
    //关闭
    closeCourseFunc() {
      this.courseflag = false;
    },
    //获取商品信息
    getProductInfo() {
      mall
        .getProductInfo(
          this.siteConfig.agencyId,
          this.productId,
          this.loginUser.userId ?? 0
        )
        .then((res) => {
          //console.log("productInfo", res);
          if (res.status == 1) {
            this.productInfo = res.data.product;
            this.courseList = res.data.courseList;
            this.teacherList = res.data.teacherList;

            //课程处理
            if (this.courseList && this.courseList.length > 0) {
              this.courseInfo = this.courseList[0];
              this.setCourseId(this.courseInfo.courseId);
              if (
                this.courseInfo.coursespecialtypeList &&
                this.courseInfo.coursespecialtypeList.length > 0
              ) {
                this.currentSpecial = this.courseInfo.coursespecialtypeList[0];
                this.setCourseSpecialId(this.currentSpecial.cstId);
              }
              this.getCourseCatalog();
            }

            this.getCourseStatisticsInfo();

            //是否购买过
            this.setIsBuy(res.data.isBuy == 0 ? false : true);
            // if (this.isBuy) {
            //   this.umcInfo = res.data.umc;
            //   this.setUmcId(this.umcInfo.umcId);
            // }
          }
        });
    },
    //获取课程统计信息
    getCourseStatisticsInfo() {
      mall
        .getCourseInfo(
          this.courseId,
          Object.keys(this.loginUser).length > 0 ? this.loginUser.userId : 0,
          this.siteConfig.agencyId,
          this.productId
        )
        .then((res) => {
          //console.log("courseInfo", res.data.courseSpecialTypesByCourse);
          if (res.status === 1) {
            this.courseStatisticsInfo = res.data;

            //处理班型统计数据
            if (this.courseStatisticsInfo) {
              this.specialStatisticsWithVideo =
                this.courseStatisticsInfo.courseSpecialTypesByCourse.filter(
                  (m) => m.specialType === 1
                );
              const a =
                this.courseStatisticsInfo.courseSpecialTypesByCourse.filter(
                  (m) => m.specialType === 3
                );
              const b =
                this.courseStatisticsInfo.courseSpecialTypesByCourse.filter(
                  (m) => m.specialType === 4
                );
              const c =
                this.courseStatisticsInfo.courseSpecialTypesByCourse.filter(
                  (m) => m.specialType === 2
                );
              this.specialStatisticsWithExercise = [...a, ...b, ...c];
            }
          }
        });
    },
    //商品购买
    buyProduct() {
      saveBuyProduct(this.productId, this.buyType);
      this.$router.push({ name: "BuyProduct" });
    },
    //获取课程目录
    getCourseCatalog() {
      mall
        .getCourseCatalog(
          this.courseId,
          this.courseSpecialId,
          this.currentSpecial.type,
          this.loginUser.userId,
          this.siteConfig.agencyId
        )
        .then((res) => {
          //console.log("catalog", res);
          if (res.status === 1) {
            this.isLoaded = true;

            //无目录时处理
            if (!res.data || res.data.length == 0) {
              this.setCourseCatalog([]);
              this.setPptId("");
              this.setVideoId("");
              if (this.currentSpecial.type === 2) {
                this.noVideoText = "该班型视频正在准备中";
              }
            }

            //章节
            if (this.currentSpecial.type === 1) {
              this.setCourseCatalog(res.data);
              //查找并设置视频ID
              if (res.data.length > 0) {
                const one = res.data[0];
                if (one.childList && one.childList.length > 0) {
                  const two = one.childList[0];
                  if (two.childList && two.childList.length > 0) {
                    const three = two.childList[0];
                    if (three.isTryLook == 1) {
                      this.setVideoId(three.bVideoId);
                    } else {
                      this.noVideoText =
                        "当前课程视频不支持试看，请购买后进行学习";
                    }
                  }
                }
              }
            }
            //串讲
            if (
              this.currentSpecial.type === 2 &&
              res.data &&
              res.data.length > 0
            ) {
              const reviewPptList = res.data[0].pptList || [];
              const liveList = res.data[0].live;
              let resultList = [];
              if (reviewPptList && reviewPptList.length) {
                resultList = reviewPptList.map((m) => {
                  return {
                    type: 1,
                    ...m,
                  };
                });
              }
              if (liveList && liveList.length) {
                const liveTemp = liveList.map((m) => {
                  return {
                    type: 2,
                    isTryLook: 0,
                    ...m,
                  };
                });
                resultList = [...resultList, ...liveTemp];
              }
              if (
                (resultList && resultList.length) ||
                (reviewPptList && reviewPptList.length > 0)
              ) {
                this.setReviewCatalog(resultList);
                let current = reviewPptList[0];
                if (current.isTryLook === 1) {
                  this.setPptId(current.PptId);
                  this.setVideoId(current.bVideoId);
                } else {
                  this.noVideoText = "当前课程视频不支持试看，请购买后进行学习";
                }
              }
            }
          }
        });
    },
  },
  components: {
    VideoPlayer,
    CourseCatalog,
    ReviewCatalog,
    TeacherSlider,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
.detail-wrapper {
  background: url("../../assets/images/v3/product-detail-bg.png") no-repeat
    bottom;
}
//播放位置
.prodet-bg {
  background: #2f3133 url("../../assets/images/v3/player-bg-p.png") no-repeat
    top;
  width: 100%;
  padding-top: 70px;
  .por-box-location {
    height: 70px;
    line-height: 70px;
    color: #999;
    font-size: 16px;
    i {
      vertical-align: -0.08em;
    }
    span {
      .inline-block();
      margin-left: 10px;
      & > span {
        height: 26px;
        line-height: 26px;
        padding: 0 12px;
        border-radius: 4px;
        vertical-align: 0.08em;
        .background-primary();
      }
    }
  }
  .prodet-player {
    width: 100%;
    .prodet-box-c {
      float: left;
      width: 800px;
      height: 500px;
      background: #e4ebef;
    }
    .prodet-box-d {
      float: left;
      width: 400px;
      height: 500px;
      background: #1b1b1b;
      .prodet-boxd-a {
        float: left;
        width: 336px;
        height: 500px;
        padding: 12px 0 11px 0;
      }
      .prodet-boxd-b {
        width: 64px;
        height: 500px;
        float: right;
        background: #000;
        position: relative;
        .prodet-pt-a {
          position: relative;
          width: 64px;
          height: 64px;
          padding: 10px 0;
          .background-primary();
          text-align: center;
          color: #fff;
          &:before {
            position: absolute;
            content: " ";
            border: 8px solid transparent;
            border-right: 8px solid #27a3ff;
            bottom: 25px;
            left: -16px;
          }
          i {
            width: 26px;
            height: 26px;
            padding: 2px 0;
            font-size: 22px;
          }
          p {
            font-weight: bold;
            font-size: 12px;
          }
        }
      }
    }
  }
  .prodet-action {
    .prodet-box-f {
      width: 100%;
      padding: 20px 0;
      text-align: right;
      .prodet-boxf-c {
        .inline-block();
        margin-right: 20px;
        color: #fe3416;
        // -webkit-background-clip: text;
        // background-image: linear-gradient(135deg, #fd6e22, #fe3416);
        font-size: 32px;
        font-weight: bold;
      }
      .prodet-boxf-b {
        .inline-block();
        font-size: 20px;
        color: #666;
        line-height: 40px;
        margin-right: 20px;
        text-decoration: line-through;
        margin-top: 10px;
      }
      .ivu-btn-warning {
        border: none;
        .background-warning();
        width: 100px;
      }
    }
  }
}

// 通用标题
.product-info-bar {
  width: 200px;
  height: 40px;
  line-height: 40px;
  background: url("../../assets/images/v3/product-detail-title.png") no-repeat
    left center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-indent: 1em;
}
//课程信息按钮
.product-info-btn {
  width: 92px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  background: linear-gradient(to right, #27a3ff, #2380fb);
  transition: transform 0.2s ease;
}

// 商品详情内容
.product-detail {
  width: 800px;
  background: white;
  float: left;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 20px 30px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  .product-info-bar {
    margin-left: -30px;
  }
  .product-info-title {
    padding: 30px 0 10px 0;
    font-size: 22px;
    color: #414141;
  }
  .product-info-sub {
    padding: 30px 0 10px 0;
    font-size: 18px;
    color: #666;
  }
  .product-info-body {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px dashed #ddd;
    &.col1 {
      li {
        width: 100%;
      }
    }
    li {
      width: 50%;
      color: #666;
      font-size: 16px;
      display: flex;
      margin: 5px 0;
      .info-item {
        span {
          font-size: 22px;
          color: #999;
          line-height: 1;
          vertical-align: -0.1em;
        }
      }
      .info-content {
        flex: 1;
        em {
          font-style: normal;
        }
        span {
          color: #999;
          margin-right: 10px;
          display: inline-block;
        }
        & > span {
          min-width: 160px;
        }
      }
    }
  }
  .product-course-list {
    border-bottom: 1px dashed #ddd;
    dl {
      dt {
        font-weight: bold;
        color: #666;
        font-size: 16px;
      }
      dd {
        display: inline-block;
        margin-right: 20px;
        margin-top: 5px;
        margin-bottom: 20px;
        color: #666;
        font-size: 16px;
      }
    }
  }
  .product-info-textbook {
    font-size: 16px;
    border-bottom: 1px dashed #ddd;
    padding-bottom: 20px;
    .product-info-center {
      display: flex;
      flex-wrap: wrap;
    }
    .product-info-line {
      width: 100%;
      flex-shrink: 0;
      height: 1px;
      background-color: #eee;
      margin: 18px 0;
    }
    .textbook-img {
      width: 80px;
      height: 100px;
    }
    .textbook-info {
      color: #999;
      flex: 1;
      .textbook-name {
        font-size: 20px;
        color: #666;
        margin-bottom: 6px;
        .textbook-name-in{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      span {
        font-size: 16px;
        line-height: 2;
        margin-left: 8px;
        margin-right: 50px;
      }
    }
  }
  .product-info-detail {
    margin-top: 30px;
    text-align: center;
    width: 100%;
    /deep/img {
      display: inline-block;
    }
  }
}
//侧边栏
.product-sider {
  width: 370px;
  float: right;
  background: #fff;
  margin-top: 30px;
  padding: 20px 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  .product-info-bar {
    margin-left: -10px;
    margin-bottom: 30px;
  }
}
</style>
